import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import ModaleDefaut from '@/components/ModaleDefaut/ModaleDefaut';

import styles from '@/modals/ContentModalRenonciation/styles.module.css';

interface ModalRenonciationErrorProps {
  nomProduit: string;
  isRetractation: boolean;
  onRetry: () => void;
  onClose: () => void;
}

const ModalRenonciationError = ({ nomProduit, isRetractation, onRetry, onClose }: ModalRenonciationErrorProps) => {
  const { t } = useTranslation();
  const prefix = isRetractation ? 'modals.cancelableModal.retractation.' : 'modals.cancelableModal.';

  return (
    <ModaleDefaut
      title={t(`${prefix}title`, { nomContrat: nomProduit })}
      content={
        <div className={styles.initialContent}>
          <p className={styles.errorMessage}>{t(`${prefix}errorMessage`)}</p>
          <div className={styles.buttonsRow}>
            <MtxButton variant="primary" size="large" fullWidth onClick={onRetry}>
              <div>{t('common.tryAgain')}</div>
            </MtxButton>
            <MtxButton variant="tertiary" size="large" fullWidth onClick={onClose}>
              <div>{t('common.close')}</div>
            </MtxButton>
          </div>
        </div>
      }
      onClickClose={onClose}
      size="large"
      mobileStyle="stick-to-bottom"
    />
  );
};

export default ModalRenonciationError;
